import * as React from "react";
import { forwardRef } from "react";
const SvgIconCopy = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 5v13.909h3.273v-1.636H6.636V6.636h10.637v1.637h1.636V5zm4.091 4.091V23H23V9.091zm1.636 1.636h10.637v10.637H10.727z", "data-name": "icon/copy", transform: "translate(-5 -5)", fill: "#57728a" }));
const ForwardRef = forwardRef(SvgIconCopy);
export { ForwardRef as ReactComponent };
